import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import store from "../store/index.js";
import { getCookie } from "@/utils/index";
let router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
let whiteRoutes = [
  "/index",
  "/404",
  "/gather/manage",
  "/gather/log",
  "/register/search",
  "/message/search",
  "/message/detail",
  "/event/list",
  "/event/list/stencil",
  "/event/list/listItem",
  "/event/list/config",
  "/event/list/rules",
  "/event/list/data",
  "/event/list/gameList",
];
router.beforeEach((to, from, next) => {
  let isHasRoutes = whiteRoutes.findIndex(f => f === to.path);
  if (isHasRoutes === -1) {
    next({ name: "404" });
  }
  let loginToken = getCookie("cstp-access-token-jwt");
  store.commit("settings/tokenChange", loginToken);
  // token存储
  if (!loginToken) {
    window.location.href = "/auth/login";
  }
  if (to.path !== "/index") {
    store.commit("settings/loadingChange", true);
  }
  next();
});
router.afterEach(() => {
  setTimeout(() => {
    store.commit("settings/loadingChange", false);
  }, 2000);
  store.commit("settings/drawerVisbleChange", false);
});
export default router;
